export const sidebarContentEnum = {
	default: null,
	cart: 'cart',
	order: 'order',
	coupon: 'coupon',
	nav: 'nav'
}
